import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 388px;
  gap: ${themeGet('space.3')}px;
  background-color: ${themeGet('colors.background.screen')};
  border-radius: 16px;
  box-shadow: ${themeGet('shadows.block')};
  padding-inline: ${themeGet('space.5')}px;
  padding-block: ${themeGet('space.11')}px;

  > img {
    width: 120px;
    height: 120px;
  }
`
